export default __webpack_public_path__ + "static/media/noun_tick_1611480.c153df2b.svg";